import React from 'react'
import SelectBox from '../common/SelectBox'
import ProfileInput from '../common/ProfileInput'
import {
  presenceErrorClass,
} from 'servos/formValidations'

const states = [
  { value: 'ACT', label: 'ACT' },
  { value: 'NSW', label: 'NSW' },
  { value: 'NT', label: 'NT' },
  { value: 'QLD', label: 'QLD' },
  { value: 'SA', label: 'SA' },
  { value: 'TAS', label: 'TAS' },
  { value: 'VIC', label: 'VIC' },
  { value: 'WA', label: 'WA' },
];

class DriverLicense extends React.Component {
  render() {
    const {
      id,
      errors,
      selectedState,
      handleStateOfIssue,
      handleInput,
      driverLicenseNumber,
    } = this.props;


    return (
      <div className='w-50 ml-2 pl-3 pt-2 border-left border-green'>
        <div className='form-group'>
          <div className="row mt-2">
            <ProfileInput
              id={id}
              label='Licence Number'
              value={driverLicenseNumber}
              handleInput={handleInput}
              errors={errors}
              className='col-12'
            />
          </div>
          <div className="row mt-2">
            <SelectBox
              label={'State of issue'}
              selectedOption={states.filter( ({value}) => value == selectedState) }
              onChange={handleStateOfIssue}
              options={states}
              errorMessage={errors['stateOfIssue']}
              className='col-12'
            />
          </div>
        </div>
      </div>
    )
  }
}

export default DriverLicense;
